import type { DrawerProps } from 'antd'
import { Divider, Drawer, Menu } from 'antd'
import type { MenuProps } from 'antd'
import type { ISideMenu } from '../../configs'
import IconFont from '@/app/components/icon-font'
import './index.css'
import { getIcon } from './CollapsibleSidebar'
import { usePathname } from 'next/navigation'
import { getSelectedKey } from '@/app/components/mlops/Sidebar'
import { useTranslation } from 'react-i18next'
export { default as CollapsibleSidebar } from './CollapsibleSidebar'
export type { ICollapsibleSidebarProps } from './CollapsibleSidebar'

export type ISidebarProps = {
  menus: Record<string, ISideMenu[]>
  visible?: boolean
  parent?: HTMLElement
  triggerSubMenuAction?: 'click' | 'hover'

  onItemClick?: (m: ISideMenu, domEvent: any) => void
} & DrawerProps

function processMenu(
  menus: ISideMenu[],
  t: (key: string) => string,
  onItemClick?: (m: ISideMenu, domEvent: any) => void,
): MenuProps['items'] {
  const walk = (menu: ISideMenu) => {
    const children: any = menu.children?.map(m => walk(m))
    const res: Required<MenuProps>['items'][number] = {
      className: 'sidebar-menu-item',
      label: (
        <span>
          {menu.msg ? t(menu.msg) : t(`routerConfig.${menu.title}`)}
        </span>
      ),
      icon: (
        <div className='sidebar-menu-icon'>
          <IconFont type={getIcon(menu)} width={18} />
        </div>
      ),
      key: menu.path || menu.title,
      children,
      type: menu.type,
      onClick: ({ domEvent }) => onItemClick?.(menu, domEvent),
    }
    return res
  }
  return menus.map(m => walk(m))
}

export default function Sidebar(props: ISidebarProps) {
  const { menus, parent, triggerSubMenuAction, onItemClick, ...drawerProps } =
    props
  const pathname = usePathname()
  const basePath = process.env.NEXT_PUBLIC_BASE_URL
  const { t } = useTranslation()

  return (
    <Drawer
      closable={false}
      getContainer={parent}
      zIndex={25}
      styles={{
        wrapper: { width: '200px', top: '50px' },
        body: { padding: '4px', paddingTop: '12px' },
      }}
      placement='left'
      {...drawerProps}>
      {Object.entries(menus).map(([k, menu]) => (
        <div key={k}>
          {k !== 'home' && (
            <Divider className='divider' orientation='left' plain>
              <span className='divider-text'>{t(`routerConfig.routesGroup.${k}`)}</span>
            </Divider>
          )}
          <Menu
            selectable={false}
            triggerSubMenuAction={triggerSubMenuAction}
            items={processMenu(menu, t, onItemClick)}
            className='submenu'
            selectedKeys={[
              getSelectedKey(basePath + pathname, menu) || '/llm/ecs/overview',
            ]}
          />
        </div>
      ))}
    </Drawer>
  )
}
